import React, { useState, useEffect } from 'react';
import ContainerLoaderCharts from '../logistica/Charts/ContainerLoaderCharts';
import stilePulsanti from '../interfaccia/stilePulsanti';
import SettingBooleano from './SettingBooleano';

function StatSpedAnni({
  mobile
}) {
  
    const {
        buttonClassesWhite,
        buttonClassesGreen,
        buttonClassesOrange
    } = stilePulsanti

    const questAnno = new Date().getFullYear()
    const palette = ["#e53935", "#3949ab", "#00897b", "#fb8c00", "#6d4c41", "#7b1fa2"];
    const yearColors = {
        [questAnno]: palette[0],
        [questAnno - 1]: palette[1],
        [questAnno - 2]: palette[2],
        [questAnno - 3]: palette[3],
        [questAnno - 4]: palette[4],
        [questAnno - 5]: palette[5],
    };

    const [settings, setSettings] = useState({
        series: {
            [questAnno]: true,
            [questAnno - 1]: true,
            [questAnno - 2]: true,
            [questAnno - 3]: true,
            [questAnno - 4]: true,
            [questAnno - 5]: true
        },        
        anni: 6,
        robaDaSommare: "importo"
    })

  return (
    
        <div className='sfondoBiancoTema tc pa3'>
        <h3>Ordini per anno</h3>
            <div className='flex items-center justify-center'>
                {/* <div>ultimi</div>
            <input
                type='number'
                value={settings.anni}
                onChange={(e)=>setSettings({...settings,anni:e.target.value})}
                className={stilePulsanti.inputClassesRicercaOrizzontale}
                min={1}
                max={6}
            />
            <div className='mr4'>anni</div> */}
            {Object.keys(settings.series).map((mp) => {
                const attivo = settings.series[mp];
                const colore = yearColors[mp];
                return (
                    <button
                        key={mp}
                        onClick={() =>
                            setSettings({
                                ...settings,
                                series: { ...settings.series, [mp]: !attivo },
                            })
                        }
                        className="ma1 pa2 pointer br2 f6 b--none"
                        style={{
                            backgroundColor: attivo ? colore : "#f5f5f5",
                            color: attivo ? "#fff" : "#333",
                            border: attivo ? "none" : "1px solid #ccc",
                            minWidth: "3.5rem",
                        }}
                    >
                        {mp}
                    </button>
                );
            })}
            <div className='ml4 mr3'>importo ordini/numero ordini</div>
            <SettingBooleano 
                value={settings.robaDaSommare}
                    trueButtonClass={buttonClassesOrange}
                    falseButtonClass={buttonClassesGreen}
                    trueElement={"importo"}
                    falseElement={"ordini"}
                    setTrue={()=>setSettings({...settings,robaDaSommare:"importo"})}
                    setFalse={()=>setSettings({...settings,robaDaSommare:"ordini"})}
                    customValueTrue={"importo"}
                    customValueFalse={"ordini"}
            />
            </div>   
            <ContainerLoaderCharts 
                query={`/contab/charts/xSettimaneAnnoyOrdini?`+ new URLSearchParams({anni: settings.anni, robaDaSommare: settings.robaDaSommare})}
                titolo="Ordini anni"
                tipo ="linesSpedizioniAnni"
                displayTitolo={false}
                settings={settings}
                colorMap={yearColors}
            />
        </div>
  )
}

export default StatSpedAnni;
